var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"pc_container"},[_c('banner'),_c('quickStart')],1),_c('section',{staticClass:"mobile_container"},[_c('mobile-product-description')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }